export enum WorkflowStepStatus {
    Disabled = 0,
    Active = 1,
    Completed = 2,
    Rejected = 3,
}
